var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramStay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 28,
    viewBox: "0 0 172 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_17109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5066 8.89474L18.3627 22.6807H4.65038L11.5066 8.89474ZM11.5066 2.43359L0 25.5658H23.0105L11.5066 2.43359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5066 14.0303L8.21973 20.6229H14.7934L11.5066 14.0303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.193 26.3426L144.92 8.70719L138.995 26.3065L135.062 24.9735L142.899 1.69172L144.632 1.67625L146.82 1.6582L155.101 24.94L151.193 26.3426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.969 19.1288L145.089 16.2373L142.209 19.1288L145.089 22.0202L147.969 19.1288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0315 1.6084H57.8818V26.3881H62.0315V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3479 1.6084H69.1982V26.3881H73.3479V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.019 11.2213L59.2881 15.2402L60.6281 19.1835L72.3591 15.1646L71.019 11.2213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.356 27.3761L103.803 24.0889L109.673 19.4892L102.296 10.4575L111.877 0.624023L114.845 3.53747L107.863 10.7025L115.577 20.1493L106.356 27.3761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.575 1.63965H118.981V5.80613H133.575V1.63965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.352 3.72266H124.202V26.3573H128.352V3.72266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1624 1.63965H38.5693V5.80613H53.1624V1.63965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9416 3.72266H43.792V26.3573H47.9416V3.72266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.729 16.5707L155.104 2.83623L158.837 1.01855L163.583 10.8547L168.256 1.02887L172 2.82592L165.467 16.5604L161.729 16.5707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.624 14.124H161.475V26.9793H165.624V14.124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1942 28L76.2295 13.1466L85.3659 0L88.7709 2.3849L81.3421 13.0744L90.5299 25.5171L87.1942 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8634 11.0273H78.7871V15.1938H88.8634V11.0273Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_17109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramStay);
export default __webpack_public_path__ + "static/media/programStay.1d966de55529e5b1d0623757e9ddb572.svg";
export { ForwardRef as ReactComponent };